'use strict';

exports.__esModule = true;
exports.getTranslate = exports.getTranslationsForActiveLanguage = exports.customeEqualSelector = exports.getActiveLanguage = exports.getLanguages = exports.getTranslations = exports.setActiveLanguage = exports.setLanguages = exports.addTranslation = exports.localeReducer = exports.TRANSLATE = exports.SET_ACTIVE_LANGUAGE = exports.SET_LANGUAGES = exports.ADD_TRANSLATION = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.languages = languages;
exports.translations = translations;

var _redux = require('redux');

var _flat = require('flat');

var _reselect = require('reselect');

var _utils = require('../utils');

var ADD_TRANSLATION = exports.ADD_TRANSLATION = '@@localize/ADD_TRANSLATION';
var SET_LANGUAGES = exports.SET_LANGUAGES = '@@localize/SET_LANGUAGES';
var SET_ACTIVE_LANGUAGE = exports.SET_ACTIVE_LANGUAGE = '@@localize/SET_ACTIVE_LANGUAGE';
var TRANSLATE = exports.TRANSLATE = '@@localize/TRANSLATE';

/**
 * REDUCERS
 */
function languages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  var _ret = function () {
    switch (action.type) {
      case SET_LANGUAGES:
        var languageCodes = action.payload.languageCodes;
        var activeLanguage = action.payload.activeLanguage || languageCodes[0];
        var activeIndex = languageCodes.indexOf(activeLanguage);
        return {
          v: languageCodes.map(function (code, index) {
            var isActive = index === activeIndex;
            return { code: code, active: isActive };
          })
        };
      case SET_ACTIVE_LANGUAGE:
        return {
          v: state.map(function (language) {
            return language.code === action.payload.languageCode ? _extends({}, language, { active: true }) : _extends({}, language, { active: false });
          })
        };
      default:
        return {
          v: state
        };
    }
  }();

  if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
}

function translations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case ADD_TRANSLATION:
      return _extends({}, state, (0, _flat.flatten)(action.payload.translation, { safe: true }));
    default:
      return state;
  }
}

var localeReducer = exports.localeReducer = (0, _redux.combineReducers)({ languages: languages, translations: translations });

/**
 * ACTION CREATORS
 */
var addTranslation = exports.addTranslation = function addTranslation(translation) {
  return {
    type: ADD_TRANSLATION,
    payload: { translation: translation }
  };
};

var setLanguages = exports.setLanguages = function setLanguages(languageCodes) {
  var activeLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: SET_LANGUAGES,
    payload: { languageCodes: languageCodes, activeLanguage: activeLanguage }
  };
};

var setActiveLanguage = exports.setActiveLanguage = function setActiveLanguage(languageCode) {
  return {
    type: SET_ACTIVE_LANGUAGE,
    payload: { languageCode: languageCode }
  };
};

/**
 * SELECTORS
 */
var getTranslations = exports.getTranslations = function getTranslations(state) {
  return state.translations;
};
var getLanguages = exports.getLanguages = function getLanguages(state) {
  return state.languages;
};
var getActiveLanguage = exports.getActiveLanguage = function getActiveLanguage(state) {
  return getLanguages(state).find(function (language) {
    return language.active === true;
  });
};

var customeEqualSelector = exports.customeEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, function (cur, prev) {
  var isTranslationsData = !(Array.isArray(cur) || Object.keys(cur).toString() === 'code,active');

  // for translations data use keys for comparison
  if (isTranslationsData) {
    prev = Object.keys(prev).toString();
    cur = Object.keys(cur).toString();
  }

  return prev === cur;
});

var getTranslationsForActiveLanguage = exports.getTranslationsForActiveLanguage = customeEqualSelector(getActiveLanguage, getLanguages, getTranslations, function (activeLanguage, languages, translations) {
  var activeLanguageCode = activeLanguage.code;

  var activeLanguageIndex = (0, _utils.getIndexForLanguageCode)(activeLanguageCode, languages);
  return Object.keys(translations).reduce(function (prev, key) {
    var _extends2;

    return _extends({}, prev, (_extends2 = {}, _extends2[key] = translations[key][activeLanguageIndex], _extends2));
  }, {});
});

var getTranslate = exports.getTranslate = function getTranslate(state) {
  var translations = getTranslationsForActiveLanguage(state);
  return function (key, data) {
    return (0, _utils.getLocalizedElement)(key, translations, data);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/lib/modules/locale.js
// module id = 395
// module chunks = 0